import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { KnBrQuoteSaveComponent } from './kn-br-quote-save.component';

@NgModule({
    imports: [
        CommonModule,
        I18nModule,
        ConfigModule.withConfig({
            cmsComponents: {
                QuoteSaveButton: {
                    component: KnBrQuoteSaveComponent,
                },
            },
        } as CmsConfig),
        KnBrQuoteSaveComponent,
    ],
    exports: [KnBrQuoteSaveComponent],
})
export class KnBrQuoteSaveModule {}
